import React from 'react';
import { Square, Stack } from '@grubhubprod/gh-cookbook-react';
import PageHeader from 'src/components/enterprise/layout/PageHeader';
import { PageTitle } from 'src/components/enterprise/layout/PageTitle/PageTitle';
import { Breadcrumbs } from 'src/components/Breadcrumbs/Breadcrumbs';
import { useAuth } from 'src/components/AuthProvider/AuthProvider';
import { EmployeeDetailsWrapper } from 'src/components/enterprise/features/Employee/EmployeeDetailsPage/components/EmployeeDetailsWrapper/EmployeeDetailsWrapper';
import {
  buildCAUIPath,
  buildCMUIPath,
  CAUIPage,
  CMUIPage,
  getHomeBreadcrumb,
} from 'src/constants/urls';
import { EmployeeGroupsWrapper } from 'src/components/enterprise/features/Employee/EmployeeDetailsPage/components/EmployeeGroupsWrapper/EmployeeGroupsWrapper';
import { useEmployeeListFeatureAccess } from 'src/components/enterprise/features/Employee/Routes/useEmployeeListFeatureAccess/useEmployeeListFeatureAccess';

export const EmployeeDetailsPage: React.FC = () => {
  const { corpId } = useAuth();
  const { canAccessEmployeeList } = useEmployeeListFeatureAccess();
  return (
    <Square inset="lg">
      <PageHeader>
        <PageTitle title="Employee Details" />
        <Breadcrumbs
          breadcrumbs={[
            {
              label: 'Admin home',
              ...getHomeBreadcrumb(corpId),
            },
            {
              label: 'Employees',
              href: canAccessEmployeeList
                ? buildCMUIPath(CMUIPage.EMPLOYEES, { corpId })
                : buildCAUIPath(CAUIPage.EMPLOYEES, { corpId }),
              useRouterLink: canAccessEmployeeList,
            },
          ]}
        />
      </PageHeader>
      <Stack y="md">
        <EmployeeDetailsWrapper />
      </Stack>
      <EmployeeGroupsWrapper />
    </Square>
  );
};
